export enum EngagementTabs {
    objectives = 'objectives',
    clientResponsibilities = 'clientResp',
    services = 'services',
    deliverables = 'deliverables',
    milestones = 'milestones',
    assumptions = 'assumptions',
    exclusions = 'exclusions',
    dependencies = 'dependencies',
    acceptanceCriteria = 'acceptanceCriteria',
    paymentTerms = 'paymentTerms',
    billingTerms = 'billingTerms',
    signatures = 'signatures',
}
export enum PayTerms {
    net15 = 'Net 15',
    net30 = 'Net 30',
    net60 = 'Net 60',
    net90 = 'Net 90',
    uponReceipt = 'Upon Receipt',
    custom = 'Custom',
}